import type { BranchMember } from '@/entities/Branch';

export function getMemberPositions(members: BranchMember[], memberId: number | null) {
  return members.find((member) => member.id === memberId)?.positions ?? [];
}
